module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/root.fd9883dfb4d046d0bbf54e8034392c56-ccahPlaceHolder-d1800.jpg";